<template>
  <section class="page-header">
    <header class="page-header__hgroup">
      <h1 class="page-header__title">Bloc Solutions</h1>
      <p>Bloc Solutions is a platform that simplifies rental management and landlord-tenant relations. The platform facilitates the daily life of its users with many features like building and unit management, communication with tenants as well as employees, electronic forms, payment and more. </p>
    </header>

    <section class="layout-section__group">
      <h2 class="layout-section__heading">My contributions</h2>
      <p>I started working in the early stages of this startup in 2017 until 2022. I worked on different projects both in development and design. Here is a short summary of some of the projects I have worked on over the years:</p>
      <br />

      <ul class="layout-section__list">
        <li>Design & development of the website and dadicated landing pages</li>
        <li>Style guide & brand identity</li>
        <li>Marketing design (ads, mail & social media publications)</li>
        <li>Component library for the plateform</li>
        <li>Documentation (branding, webdesign & development)</li>
      </ul>
    </section>

    <!-- <section class="layout-section__group">
      <div class="layout-section__hgroup -spacing-bigger">
        <h2 class="layout-section__heading">My contributions</h2>
        <p>J'ai travillé pour Bloc Solutions depuis les debut en 2017 jusqu'en 2022. J'ai travaillé sur differents projet autant en integration qu'au design. Blablablabla.  Voici quelques projets sur lesquels j'ai travaillé durant mes 5 ans chez Bloc Solutions : </p>
      </div>
    </section>

    <section class="layout-section__group">
      <article class="layout-section__subgroup">
        <div class="layout-section__hgroup -spacing-smaller">
          <h3 class="layout-section__label">Refonte du site Web [2021 - 2022]</h3>
          <p>The precedent version of the website struggled to deliver a clear and legible message. There was no strong identity nor structure. </p>
        </div>

        <ul class="layout-section__list">
          <li>Modernisation du UI, By adding a lighter and more modern look to it, the idea was to appeal to a larger audience.</li>
          <li>Restructuration des pages du site web. Aider le clients à mieux compprendre le produits et les services</li>
          <li>Cycle locatif</li>
          <li>Ajout d'un formulaire de contact - sujet selon bouton</li>
          <li>Optimisation du SEO</li>
          <li>Integration du site web en SCSS et Nuxt.js</li>
        </ul>
      </article>

      <article class="layout-section__subgroup">
        <div class="layout-section__hgroup -spacing-smaller">
          <h3 class="layout-section__label">Amélioration de l’image de marque en marketing [2021 - 2022]</h3>
          <p>Modernidation du branding pour donner un look plus proffessionel pour les reseaux sociaux, les Ads, etc.</p>
        </div>

        <ul class="layout-section__list">
          <li>Restructuration des guidelines</li>
          <li>Creation de template pour des postes de reseaux sociaux (Instagram, Facebook)</li>
          <li>Creation de template pour les mails</li>
          <li>Advertising design (Google Ads, Magazines, etc.)</li>
        </ul>
      </article>

      <article class="layout-section__subgroup">
        <div class="layout-section__hgroup -spacing-smaller">
          <h3 class="layout-section__label">Dedicated landing page "Dragons" [2020]</h3>
          <p>Lors du passage de Blos Solutions dans l'émission "Dans l'oeil du Dragon", nous avions creer un dadicated landing page qui etait</p>
        </div>

        <ul class="layout-section__list">
          <li>Design from wireframing to prototyping.</li>
          <li>Integration en SCSS et Vue.js</li>
        </ul>
      </article>

      <article class="layout-section__subgroup">
        <div class="layout-section__hgroup -spacing-smaller">
          <h3 class="layout-section__label">Création du bail électronique</h3>
          <p>Le creation d'un bail electronique etait la premiere festure officiele de Bloc Solutions. Aucune autre plateforme Quebecoise avait un produit similaire sur le marché. Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto dolorum magni laboriosam magnam, quod dolores repellendus non laudantium sit voluptatibus voluptate distinctio soluta quas rem sed blanditiis maiores sequi!</p>
        </div>

        <ul class="layout-section__list">
          <li>Analyse du bail officiele de la Regie du logement </li>
          <li>Intégration du formulaire</li>
        </ul>
      </article>


      <article class="layout-section__subgroup">
        <div class="layout-section__hgroup -spacing-smaller">
          <h3 class="layout-section__label">Design system</h3>
          <p>Bloc Solutions design system is inspired by the principles of Atomic Design. Each component is broken down to its smallest atom.</p>
        </div>

        <ul class="layout-section__list">
          <li>.</li>
          <li>.</li>
          <li>.</li>
        </ul>
      </article> -->

      <section class="layout-section__group">
      <h2 class="layout-section__heading">Tools</h2>

      <ul class="layout-section__list">
        <li>Adobe XD, Figma, Photoshop, Illustrator</li>
        <li>HTML, SCSS, Nuxt, Vue JS</li>
        <li>Strapi</li>
        <li>MailChimp, Sendgrid</li>
      </ul>
    </section>
  </section>
</template>

<script>
export default {
  name: 'BlocHeader'
}
</script>
